import React, { useState, useEffect } from 'react';
import { Form, Accordion, Row, Col, FloatingLabel, Button, Spinner } from "react-bootstrap";
import BankImg from "../assets/images/bank.svg";
import { PatternFormat } from "react-number-format";
import BillingAddress from './BillingAddress';
import { post } from '../api/transactionAPI';
import checkEcheckFormValidation from '../validation/echeckFormValidation';
import { EcheckValidationError } from './ValidationError';


export default function Echeck({ merchantData, transactionData, sendResultToParent }) {

    //field validation state:
    const [firstNameInvalidMessage, setFirstNameInvalidMessage] = useState('');
    const [lastNameInvalidMessage, setLastNameInvalidMessage] = useState('');
    const [businessNameInvalidMessage, setBusinessNameInvalidMessage] = useState('');
    const [routingNumberInvalidMessage, setRoutingNumberInvalidMessage] = useState('');
    const [accountNumberInvalidMessage, setAccountNumberInvalidMessage] = useState('');

    //form validation state:
    let errorObject = { amount: '', firstName: '', lastName: '', businessName: '', accountNumber: '', routingNumber: '', address1: '', postalCode: '', email: '' };
    const [echeckFormError, setEcheckFormError] = useState(errorObject);
    const [eCheckFormValidated, setECheckFormValidated] = useState(true);

    //loadning state:
    const [loading, setLoading] = useState(false);

    //data object state:
    let echeckObject = { bankAccountType : "", accountType: "", firstName: "", lastName: "", businessName: "", routingNumber: "", accountNumber: "" };
    const [echeckData, setEcheckData] = useState(echeckObject);

    //catch address data state:
    const [isAddressData, setIsAddressData] = useState({});
    
    //agreement check:
    const [isAgreementChecked,setIsAgreementChecked] = useState(false);

    //result state:
    let resultObject = { amount:'', achHolderName :'',paymentType : 'ACH', customerNumber :'',invoiceNumber :'',poNumber:'',
        transaction: '', message: '', messageDetail: '', transactionId: '', approvalCode: '', avsResponse: '' ,transactionDate:''};
    const [isResult, setIsResult] = useState(resultObject);

    //Firstname blur effect:
    const handleBlurOnFirstName = () => {
        let inputFirstName = echeckData.firstName.trim();

        if (inputFirstName === '') {
            setFirstNameInvalidMessage('First Name is required');
        }
    }

    //Lastname blur effect:
    const handleBlurOnLastName = () => {
        let inputLastName = echeckData.lastName.trim();

        if (inputLastName === '') {
            setLastNameInvalidMessage('Last Name is required');
        }
    }

    //Business name blur effect:
    const handleBlurOnBusinessName = () => {
        let inputBusinessName = echeckData.businessName.trim();

        if (inputBusinessName === '') {
            setBusinessNameInvalidMessage('Name on Account is required');
        }
    }

    //Routingnumber blur effect:
    const handleBlurOnRoutingNumber = () => {
        let inputRoutingNumber = echeckData.routingNumber.trim();

        if (inputRoutingNumber === '') {
            setRoutingNumberInvalidMessage('Routing / ABA Number is required');
        }
        if (inputRoutingNumber.length > 0 && inputRoutingNumber.length < 9) {
            setRoutingNumberInvalidMessage('Routing / ABA Number is invalid');
        }
    }

    //Accountnumber blur effect:
    const handleBlurOnAccountNumber = () => {
        let inputAccountNumber = echeckData.accountNumber.trim();

        if (inputAccountNumber === '') {
            setAccountNumberInvalidMessage('Account Number is required');
        }
        if (inputAccountNumber.length > 0 && inputAccountNumber.length < 4) {
            setAccountNumberInvalidMessage('Account Number is invalid');
        }
    }

    //Handle field change Input:
    const handleEcheckChangeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        if (name === 'firstName') {
            setFirstNameInvalidMessage('');
        }
        if (name === 'lastName') {
            setLastNameInvalidMessage('');
        }
        if (name === 'routingNumber') {
            setRoutingNumberInvalidMessage('');
        }
        if (name === 'accountNumber') {
            setAccountNumberInvalidMessage('');
        }
        if (name === 'businessName') {
            setBusinessNameInvalidMessage('');
        }
        // if (name === 'accountType') {
        //     setECheckFormValidated(true);
        // }

        setEcheckData({ ...echeckData, [name]: value });
    }

    //Get Address data from Billing Address component:
    const getAddressData = (data) => {
        setIsAddressData(data);
    }

    //Form Validation:
    const checkFormValidation = (field) => {
        let errors = { ...echeckFormError };
        let result = checkEcheckFormValidation(field, errors);
        setEcheckFormError(result.isErrors);
        setECheckFormValidated(result.isValid);
        return result.isValid;
    }

    //PAYMENT SUBMIT:
    const paymentSubmit = async (event) => {
        try {
            event.preventDefault();

            //check agreement:
            if(!isAgreementChecked){
                alert('Please agree to the terms and conditions before proceeding.');
                return;
            }
            
            setIsResult(resultObject);

            let echeckPaymentData = { ...echeckData, ...isAddressData, ...transactionData, ...merchantData };
            let echeckFormValid = checkFormValidation(echeckPaymentData);

            let customerPaymentInformation = {
                amount: echeckPaymentData.amount,
                achHolderName: echeckPaymentData.bankAccountType === 'Personal' ? `${echeckPaymentData.firstName} ${echeckData.lastName}` : echeckData.businessName,
                paymentType : 'ACH',
                customerNumber : echeckPaymentData.accountNumber ?? '',
            }
            if(echeckPaymentData && echeckPaymentData.invoiceNumber){
                customerPaymentInformation = {...customerPaymentInformation, invoiceNumber : echeckPaymentData.invoiceNumber};
            }
            if(echeckPaymentData && echeckPaymentData.poNumber){
                customerPaymentInformation = {...customerPaymentInformation, poNumber: echeckPaymentData.poNumber };
            }

            if (echeckFormValid) {
                setLoading(true);
                let result = await post(echeckPaymentData, 'eCheck')
                setLoading(false);


                if (result?.ResponseCode === "00") {
                    setIsResult({
                        ...customerPaymentInformation,
                        transaction: 'Approved',
                        approvalCode: result?.ApprovalCode ?? '',
                        avsResponse : result?.AvsResponse ?? '',
                        transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                        transactionDate: result?.TransactionDate ?? ''
                    });
                    return;
                } else {
                    setIsResult({
                        ...customerPaymentInformation,
                        transaction: 'Failed',
                        message: result?.ResponseMessage ?? '',
                        messageDetail: result?.ResponseMessageDetail ?? 'Transaction could not be processed',
                        avsResponse : result?.AvsResponse ?? '',
                        transactionId: result?.TransactionID ? String(result.TransactionID) : '',
                        transactionDate: result?.TransactionDate ?? ''
                    });
                    return;
                }

            }
        } catch (error) {
            setLoading(false);
            setIsResult({ transaction: 'Failed', error: true });
            return;
        }
    }

    //send success transaction result to parent:
    useEffect(() => {
            sendResultToParent(isResult);
    }, [isResult, sendResultToParent]);

    return (
        <>
            <Accordion.Header>
                <div className="accordion-headline">
                    <strong className="accordion-title d-block">eCheck</strong>
                    <span className="accordion-subtitle">Use your bank account.</span>
                </div>
                <div className="accordion-images d-none d-md-block">
                    <ul className="cardimageList" >
                        <li><img src={BankImg} alt="bank" /></li>
                    </ul>
                </div>
            </Accordion.Header>
            <Accordion.Body>
                <h3 className="accordion-title mt-2">Bank Account Information</h3>
                <Form onSubmit={paymentSubmit}>
                    
                    <Row className="gx-2">
                        
                        <Form.Group as={Col} xl={6} controlId={`floating`}>
                            <FloatingLabel controlId={`floatingBankAccountType`} label="Account Holder Type" className="mb-2">
                                <Form.Select aria-label="Floating label select" name='bankAccountType' value={echeckData.bankAccountType} onChange={handleEcheckChangeInput}>
                                    <option value="">Select</option>
                                    <option value="Business">Business</option>
                                    <option value="Personal">Personal</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Form.Group>
                        
                        <Form.Group as={Col} xl={6} controlId={`floating`}>
                            <FloatingLabel controlId={`floatingAccountType`} label="Account Type" className="mb-2">
                                <Form.Select aria-label="Floating label select" name='accountType' value={echeckData.accountType} onChange={handleEcheckChangeInput}>
                                    <option value="">Select</option>
                                    <option value="Savings">Savings</option>
                                    <option value="Checking">Checking</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Form.Group>
                        
                        {(echeckData.bankAccountType === 'Personal')
                            && (
                                <>
                                    <Form.Group as={Col} xl={6}>
                                        <FloatingLabel controlId="floatingFirstName"
                                            label={
                                                <span className={firstNameInvalidMessage ? 'text-danger' : ''}>
                                                    {firstNameInvalidMessage ? firstNameInvalidMessage : "First Name"}
                                                </span>
                                            }
                                            className="mb-2">
                                            <Form.Control
                                                // required
                                                type="text"
                                                placeholder="First Name"
                                                className={firstNameInvalidMessage ? 'border-danger' : ''}
                                                name="firstName"
                                                value={echeckData.firstName}
                                                onBlur={handleBlurOnFirstName}
                                                onChange={handleEcheckChangeInput}
                                            />
                                        </FloatingLabel>
                                    </Form.Group>

                                    <Form.Group as={Col} xl={6}>
                                        <FloatingLabel controlId="floatingLastName"
                                            label={
                                                <span className={lastNameInvalidMessage ? 'text-danger' : ''}>
                                                    {lastNameInvalidMessage ? lastNameInvalidMessage : "Last Name"}
                                                </span>
                                            }
                                            className="mb-2">
                                            <Form.Control
                                                // required
                                                type="text"
                                                placeholder="Last Name"
                                                className={lastNameInvalidMessage ? 'border-danger' : ''}
                                                name="lastName"
                                                onBlur={handleBlurOnLastName}
                                                onChange={handleEcheckChangeInput}
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                </>
                            )
                        }

                        {(echeckData.bankAccountType === 'Business')
                            && (
                                <>
                                    <Form.Group as={Col} xl={12}>
                                        <FloatingLabel controlId="floatingBusinessName"
                                            label={
                                                <span className={businessNameInvalidMessage ? 'text-danger' : ''}>
                                                    {businessNameInvalidMessage ? businessNameInvalidMessage : "Name on Account"}
                                                </span>
                                            }
                                            className="mb-2">
                                            <Form.Control
                                                // required
                                                type="text"
                                                placeholder="Name on Account"
                                                className={businessNameInvalidMessage ? 'border-danger' : ''}
                                                name="businessName"
                                                value={echeckData.businessName}
                                                onBlur={handleBlurOnBusinessName}
                                                onChange={handleEcheckChangeInput}
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                </>
                            )
                        }

                        <Form.Group as={Col} xl={6}>
                            <FloatingLabel controlId="floatingRoutingNumber"
                                label={
                                    <span className={routingNumberInvalidMessage ? 'text-danger' : ''}>
                                        {routingNumberInvalidMessage ? routingNumberInvalidMessage : "Routing / ABA Number"}
                                    </span>
                                }
                                className="mb-2">
                                <PatternFormat
                                    format="#########"
                                    mask=""
                                    id="floatingRoutingNumber"
                                    className={`form-control ${routingNumberInvalidMessage ? 'border-danger' : ''}`}
                                    placeholder="Routing / ABA Number"
                                    name='routingNumber'
                                    onBlur={handleBlurOnRoutingNumber}
                                    onChange={handleEcheckChangeInput}
                                // required
                                />
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col} xl={6}>
                            <FloatingLabel controlId="floatingAccountNumber"
                                label={
                                    <span className={accountNumberInvalidMessage ? 'text-danger' : ''}>
                                        {accountNumberInvalidMessage ? accountNumberInvalidMessage : "Account Number"}
                                    </span>
                                }
                                className="mb-2">
                                <PatternFormat
                                    format="#################"
                                    mask=""
                                    id="floatingAccountNumber"
                                    className={`form-control ${accountNumberInvalidMessage ? 'border-danger' : ''}`}
                                    placeholder="Account Number"
                                    name="accountNumber"
                                    onBlur={handleBlurOnAccountNumber}
                                    onChange={handleEcheckChangeInput}
                                // required
                                />
                            </FloatingLabel>
                        </Form.Group>

                    </Row>

                    <BillingAddress uniqueId="2"  sendAddressDataToParent={getAddressData} />

                    {/* <Row className="mt-2 mb-3">
                        <Col xs={6}>
                            <div className="payment-label">Payment</div>
                        </Col>
                        <Col xs={6} className="text-end">
                            <div className="payment-value">${transactionData.amount ? transactionData.amount : "0.00"}</div>
                        </Col>
                    </Row> */}


                    {/* Form Validation Error Show */}
                    {!eCheckFormValidated && <EcheckValidationError bankAccountType={echeckData.bankAccountType} echeckFormError={echeckFormError} />}
                    
                    {/* <Row className="mt-3">
                        <Col className="payment-disclaimer">
                            <p>By clicking on the Pay Button, I am authorizing my merchant to initiate a one-time ACH/electronic debit in the amount indicated from the bank account I have designated above. The debit is to occur approximately 3-5 business days from submission and I understand that the authorization will remain in full force and effect until the transaction is cancelled by me by contacting my merchant, or the ACH/electronic debit is processed from the designated account. Any request for cancellation shall afford my merchant a reasonable opportunity to act on such request. I certify that (1) I am authorized to debit the bank account above and (2) that the ACH/electronic payment I am authorizing complies with all applicable laws. By clicking on the Pay Button, you agree to pay the above amount and provide your information to help process your payment and detect fraud. Please see our <a href="https://securepay.com/privacy.html" rel="noopener noreferrer" target="_blank">Privacy Policy</a> for more information on our data practices.</p>
                        </Col>
                    </Row> */}
                    
                    
                    <Row className="mt-3">
                        <Col className="payment-disclaimer">
                            <div className="form-check mb-2 d-flex align-items-start">
                                <input 
                                    className="form-check-input me-2"
                                    type="checkbox" id="agreeCheckbox"
                                    checked={isAgreementChecked}
                                    onChange={(e) => setIsAgreementChecked(e.target.checked)}
                                    style={{ width: '0.86rem', height: '0.86rem' }} 
                                    required 
                                />
                                <label className="form-check-label text-dark" htmlFor="agreeCheckbox" style={{ fontSize: '0.86rem', fontStyle: 'normal' }}>
                                    By clicking on the Pay Button, I am authorizing my merchant to initiate a one-time ACH/electronic debit in the amount indicated from the bank account I have designated above. The debit is to occur approximately 3-5 business days from submission and I understand that the authorization will remain in full force and effect until the transaction is cancelled by me by contacting my merchant, or the ACH/electronic debit is processed from the designated account. Any request for cancellation shall afford my merchant a reasonable opportunity to act on such request. I certify that (1) I am authorized to debit the bank account above and (2) that the ACH/electronic payment I am authorizing complies with all applicable laws. By clicking on the Pay Button, you agree to pay the above amount and provide your information to help process your payment and detect fraud. Please see our <a href="https://securepay.com/privacy.html" rel="noopener noreferrer" target="_blank">Privacy Policy</a> for more information on our data practices.
                                </label>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mt-2 mb-2">
                        <Col className="text-end">
                            <Button type="submit" className="payment-button" variant="primary" disabled={loading}>
                                {loading ? (
                                    <>
                                        <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                                        {' '}Processing...
                                    </>
                                ) : (
                                    `Pay $${transactionData.amount ? transactionData.amount : "0.00"}`
                                )}
                            </Button>
                        </Col>
                    </Row>

                </Form>
            </Accordion.Body>
        </>
    )
}
